<template>
  <v-text-field
    :value="value"
    type="text"
    class="text-transform-capitalize"
    outlined
    dense
    @input.native="$emit('input', $event.target.value)"
    @keypress="handleKeyPress"
    :autofocus="autofocus"
    :background-color="backgroundColor"
    :rules="requiredRules"
    :label="label"
  >
  </v-text-field>
</template>

<script>
import methods from "@/shared/utility";

export default {
  props: {
    label: { type: String },
    value: { type: String },
    autofocus: { type: Boolean },
    backgroundColor: { type: String },
    isRequired: { type: Boolean, default: true },
  },
  data() {
    return {
      dataValidationRules: [(v) => this.isContactNumberValid(v)],
      requiredRules: [(v) => this.isRequired ? !!v || "Please enter a valid contact number" : true],
    };
  },

  methods: {
    handleKeyPress(event) {
      let inputValue = event.target.value;
      if (methods.allowIntegers(event)) {
        this.$emit("input", inputValue);
      } else {
        return event.preventDefault();
      }
    },
    // isContactNumberValid(contactNumber) {
    //   if (contactNumber.length == 9) {
    //     if (contactNumber[0] == 0) {
    //       return "Contact number cannot start with 0";
    //     }
    //     return true;
    //   } else {
    //     return "Contact number should be 9 digits";
    //   }
    // },
  },
};
</script>

<style></style>
